module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    staticClass: "rich-button",
    class: _vm.rootClasses
  }, 'div', _vm.cmsEditHelperAttrs, false), [_c('a', {
    staticClass: "rich-button--link btn",
    class: _vm.buttonClasses,
    attrs: {
      "href": _vm.content.href,
      "target": _vm.content.external ? '_blank' : null,
      "rel": _vm.content.external ? 'noopener noreferrer' : null
    },
    on: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [(_vm.content.headline) ? _c('span', {
    staticClass: "btn--wrap"
  }, [_c('span', {
    staticClass: "btn--text rich-button--headline",
    domProps: {
      "innerHTML": _vm._s(_vm.content.headline)
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rich-button--wrap btn--wrap"
  }, [(_vm.content.icon) ? _c('span', {
    staticClass: "rich-button--icon btn--icon"
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": _vm.content.icon,
      "size": "medium"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.content.label) ? _c('span', {
    staticClass: "rich-button--label btn--text",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rich-button--chevron btn--icon"
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "chevron_right",
      "size": "x-small"
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43871051", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43871051","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/rich-button/index.vue
// module id = 538
// module chunks = 7